import { StyleSheet, Text, View } from '@react-pdf/renderer'

export const defaultFormPdfFontFamily = 'Open Sans'
export const inuktitutFormPdfFontFamily = 'Pigiarniq'
export const pdfDefaultFontSize = 10

export const pdfTableStyles = StyleSheet.create({
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  table: {
    // @ts-expect-error
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableCol: {
    borderStyle: 'solid',
    minHeight: 16,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  centeredCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tableCell: {
    fontFamily: defaultFormPdfFontFamily,
    fontSize: 10,
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  headerTableCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 4,
    fontWeight: 'bold'
  },
  secondLevelRowCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  mainTableCell: {
    fontFamily: defaultFormPdfFontFamily,
    fontSize: 10,
    fontWeight: 'bold',
    padding: 2
  },
  helptextCell: {
    fontFamily: defaultFormPdfFontFamily,
    fontSize: 8,
    fontStyle: 'italic',
    margin: '0 2px'
  },
  elementTitle: {
    fontFamily: defaultFormPdfFontFamily,
    fontSize: 10,
    fontWeight: 'bold'
  },
  title: {
    padding: 10,
    fontSize: 16,
    fontWeight: 400
  }
})

export const commonPDFStyles = StyleSheet.create({
  sectionTitle: {
    fontSize: 12,
    color: '#17474f',
    paddingBottom: 16,
    fontWeight: 'bold'
  },
  elementTitle: {
    padding: 10,
    fontSize: 16,
    fontWeight: 400
  },
  pdfTitle: {
    paddingBottom: 16,
    fontWeight: 'bold',
    fontSize: 18,
    color: '#17474f'
  },
  row: {
    flexWrap: 'nowrap',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    border: '1px solid black',
    borderCollapse: 'collapse'
  },
  bullet: {
    width: 4,
    height: 4,
    borderRadius: 3,
    color: '#000000',
    backgroundColor: '#000000',
    marginRight: 8,
    marginTop: 4,
    flexShrink: 0
  }
})

export const PDFPageNumber = (): React.ReactElement => {
  return (
    <View
      fixed
      style={{
        position: 'absolute',
        bottom: '1.27cm',
        width: '15.92cm',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      render={({ pageNumber, totalPages }) => (
        <Text>{String(pageNumber) + '/' + String(totalPages)}</Text>
      )}
    />
  )
}
